export default __webpack_public_path__ + "static/media/close.6c86b996.svg";